export default __webpack_public_path__ + "static/moneySackRed-c52581efcb3b389eede95824b2a4a842.png";